import { Action, createReducer, on } from '@ngrx/store';

import * as EnableMfaActions from './mfa-preference.actions';
import { MfaMethod } from '@fantaz/shared/data-access/api';
import {
  FetchMFAPreferenceOutput,
  UpdateMFAPreferenceInput,
} from 'aws-amplify/auth';

export const MFA_PREFERENCE_FEATURE_KEY = 'mfaPreference';

export interface MfaPreferenceState {
  enableMfaMethod?: UpdateMFAPreferenceInput | null;
  loaded: boolean; // has the EnableMfa method been loaded
  loading: boolean; // has the EnableMfa method loading
  changeTOTP: boolean; // force change the totp app
  identityVerified: boolean; // has the identity verified
  error?: string | null; // last known error (if any)
  mFAPreference?: FetchMFAPreferenceOutput;
}

export const initialMfaState: MfaPreferenceState = {
  // set initial required properties
  loaded: false,
  loading: false,
  changeTOTP: false,
  enableMfaMethod: null,
  identityVerified: false,
};

const reducer = createReducer(
  initialMfaState,
  on(EnableMfaActions.changeTotpMfaPreference, (state) => ({
    ...state,
    changeTOTP: true,
  })),
  on(
    EnableMfaActions.updateMFAPreferenceMfa,
    (state, { updateMFAPreference }) => ({
      ...state,
      enableMfaMethod: updateMFAPreference,
      loaded: false,
      loading: true,
      error: null,
    }),
  ),
  on(EnableMfaActions.updateEnableMfaSuccess, (state) => ({
    ...state,
    loaded: true,
    enableMfaMethod: null,
    loading: false,
    error: null,
  })),
  on(
    EnableMfaActions.AuthMFAActions.loadMfAPreferenceSuccess,
    (state, { payload }) => ({
      ...state,
      mFAPreference: payload,
    }),
  ),
  on(EnableMfaActions.UpdateEnableMfaFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
);

export function enableMfaReducer(
  state: MfaPreferenceState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
